var __TEMP__ = require('./_assignMergeValue.js');var assignMergeValue = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_cloneBuffer.js');var cloneBuffer = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_cloneTypedArray.js');var cloneTypedArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_copyArray.js');var copyArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_initCloneObject.js');var initCloneObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArguments.js');var isArguments = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArray.js');var isArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArrayLikeObject.js');var isArrayLikeObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isBuffer.js');var isBuffer = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isFunction.js');var isFunction = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isObject.js');var isObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isPlainObject.js');var isPlainObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isTypedArray.js');var isTypedArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_safeGet.js');var safeGet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./toPlainObject.js');var toPlainObject = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseMergeDeep;
